import { render, staticRenderFns } from "./MedicationEdit.vue?vue&type=template&id=eb908634"
import script from "./MedicationEdit.vue?vue&type=script&lang=js"
export * from "./MedicationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports